import React from 'react';
import styles from './index.module.css';

export default function TypingMessageItem() {
  return (
    <div className={styles.messageItemWrapper}>
      <div className={styles.messageItem}>
        <div className={styles.loading}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
